
(function ( EG ) {
	'use strict';

	EG.Users.Analytics.UserAnalytics = function (pageName) {

		this.products = 'Users';
		this.channel = 'Users';
		this.pageName = pageName;
		
	}

	EG.Users.Analytics.UserAnalytics.prototype = {
		initialize : function(){
			var role;
			this.set('prop16', null);
			this.set('eVar28', null);
			// All common analytics data is to be set here
			uitk.analytics.set('products', this.products);
			uitk.analytics.set('channel', this.channel);
			uitk.analytics.set('pageName', this.pageName);

			if(EG && EG.user && EG.user.roleType) {
				role = EG.user.roleType;
			}
			if(role) {
					uitk.analytics.set('prop55', role);
					uitk.analytics.set('eVar55', role);
			}
		},
		setAnalyticsDataForProfilePage: function()	{
			this.set('pageName', this.getPageName());
			this.send();
		},
		track: function (type, options) {
			uitk.analytics.track(type, options);
			this.set('prop16', null);
			this.set('eVar28', null);
		},
		trackLoadEvent:function(context, rfrrId)	{
			this.set('prop16', rfrrId);
			this.set('eVar28', rfrrId);
			this.send();
			this.set('prop16', null);
			this.set('eVar28', null);
		},
		set:function(k, v)	{
			uitk.analytics.set(k, v);
		},
		send:function()	{
			uitk.analytics.send();
		},
		getPageName:function () {
			return this.pageName;
		},
		trackErrorMessages:function(messages) {
			uitk.analytics.set('prop36', messages);
			uitk.analytics.send();
			uitk.analytics.set('prop36', null);
		}
	};

})(window.EG || {});
